import PopupMenu from './PopupMenuLinks';

const keyCode = Object.freeze({
    'TAB': 9,
    'RETURN': 13,
    'ESC': 27,
    'SPACE': 32,
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40
});

const mediaBreakPoint = '(max-width: 1024px)';
const mq = window.matchMedia(mediaBreakPoint);

class MenuItem {
    constructor(domNode, menuObj) {
        if (typeof popupObj !== 'object') {
          var popupObj = false;
        }
        
        this.domNode = domNode;
        this.menu = menuObj;
        this.popupMenu = false;
        this.isMenubarItem = false;
        this.isMenuMobileStyle = false;
        
        this.clickHandler = this.handleClick.bind(this);
        this.keydownHandler = this.handleKeydown.bind(this);
        this.focusHandler = this.handleFocus.bind(this);
        this.blurHandler = this.handleBlur.bind(this);
        this.mouseoverHandler = this.handleMouseover.bind(this);
        this.mouseoutHandler = this.handleMouseout.bind(this);
        this.backClickHandler = this.handleBackClick.bind(this);
    }
    
    init() {
        this.domNode.tabIndex = -1;

        if (mq.matches) {
            this.isMenuMobileStyle = true;
            this.addListeners(true);
        } else if (!mq.matches) {
            this.isMenuMobileStyle = false;
            this.addListeners(false);
        }
        window.addEventListener('resize', this.handleWindowResize.bind(this));

        // Initialize flyout menu
        const nextElement = this.domNode.nextElementSibling;
        if (nextElement && (nextElement.tagName === 'UL' || nextElement.classList.contains('mega-menu'))) {
            this.popupMenu = new PopupMenu(nextElement, this);
            this.popupMenu.init();
        }
    }
    
    isExpanded() {
        return this.domNode.getAttribute('aria-expanded') === 'true';
    }
    
    addListeners(mobile) {
        if (mobile) {
            if (this.domNode.classList.contains('back')) {
                this.domNode.addEventListener('click', this.backClickHandler);
            } else {
                this.domNode.addEventListener('click', this.clickHandler);
            }

            this.domNode.removeEventListener('keydown', this.keydownHandler);
            this.domNode.removeEventListener('focus', this.focusHandler);
            this.domNode.removeEventListener('blur', this.blurHandler);
            this.domNode.removeEventListener('mouseover', this.mouseoverHandler);
            this.domNode.removeEventListener('mouseout', this.mouseoutHandler);
        } else {
            this.domNode.addEventListener('click', this.clickHandler);
            this.domNode.addEventListener('keydown', this.keydownHandler);
            this.domNode.addEventListener('focus', this.focusHandler);
            this.domNode.addEventListener('blur', this.blurHandler);
            this.domNode.addEventListener('mouseover', this.mouseoverHandler);
            this.domNode.addEventListener('mouseout', this.mouseoutHandler);
        }
    }

    /* EVENT HANDLERS */
    handleWindowResize() {
        if (mq.matches && !this.isMenuMobileStyle) {
            this.isMenuMobileStyle = true;
            this.addListeners(true);
        } else if (!mq.matches && this.isMenuMobileStyle) {
            this.isMenuMobileStyle = false;
            this.addListeners(false);
        }
    }

    handleKeydown(event) {
        var tgt  = event.currentTarget,
            char = event.key,
            flag = false,
            clickEvent;
        
        function isPrintableCharacter (str) {
            return str.length === 1 && str.match(/\S/);
        }
        
        switch (event.keyCode) {
            case keyCode.SPACE:
            case keyCode.RETURN:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToFirstItem();
                } else {
                    // Create simulated mouse event to mimic the behavior of ATs
                    // and let the event handler handleClick do the housekeeping.
                    try {
                        clickEvent = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': true
                        });
                    } catch (err) {
                        if (document.createEvent) {
                            // DOM Level 3 for IE 9+
                            clickEvent = document.createEvent('MouseEvents');
                            clickEvent.initEvent('click', true, true);
                        }
                    }
                    tgt.dispatchEvent(clickEvent);
                }
            
                flag = true;
                break;
        
            case keyCode.UP:
                this.menu.setFocusToPreviousItem(this);
                flag = true;
                break;
            
            case keyCode.DOWN:
                this.menu.setFocusToNextItem(this);
                flag = true;
                break;
        
            case keyCode.LEFT:
                this.menu.setFocusToController('previous', true);
                this.menu.close(true);
                flag = true;
                break;
        
            case keyCode.RIGHT:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToFirstItem();
                } else {
                    this.menu.setFocusToController('next', true);
                    this.menu.close(true);
                }
                flag = true;
                break;
        
            case keyCode.HOME:
            case keyCode.PAGEUP:
                this.menu.setFocusToFirstItem();
                flag = true;
                break;
        
            case keyCode.END:
            case keyCode.PAGEDOWN:
                this.menu.setFocusToLastItem();
                flag = true;
                break;
        
            case keyCode.ESC:
                this.menu.setFocusToController();
                this.menu.close(true);
                flag = true;
                break;
        
            case keyCode.TAB:
                this.menu.setFocusToController();
                break;
        
            default:
                if (isPrintableCharacter(char)) {
                    this.menu.setFocusByFirstCharacter(this, char);
                    flag = true;
                }
                break;
        }
        
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
    
    setExpanded(value) {
        if (value) {
            this.domNode.setAttribute('aria-expanded', 'true');
        } else {
            this.domNode.setAttribute('aria-expanded', 'false');
        }
    }
    
    handleClick(event) {
        this.menu.setFocusToController();
        // this.menu.close(true);

        // if (window.matchMedia('(max-width: 1024px)').matches) {
        //     this.menu.controller.menu.close();
        // }
    }
    
    handleFocus(event) {
        this.menu.hasFocus = true;
    }
    
    handleBlur(event) {
        this.menu.hasFocus = false;
        setTimeout(this.menu.close.bind(this.menu, false), 300);
    }
    
    handleMouseover(event) {
        this.menu.hasHover = true;
        this.menu.open();
        if (this.popupMenu) {
            this.popupMenu.hasHover = true;
            this.popupMenu.open();
        }
    }
    
    handleMouseout(event) {
        if (this.popupMenu) {
            this.popupMenu.hasHover = false;
            this.popupMenu.close(true);
        }
        
        this.menu.hasHover = false;
        setTimeout(this.menu.close.bind(this.menu, false), 300);
    }

    handleBackClick(event) {
        event.preventDefault();
        event.stopPropagation();
        
        if (this.popupMenu) {
            this.popupMenu.hasHover = false;
            this.popupMenu.close(true);
        }
        this.menu.hasHover = false;
        setTimeout(this.menu.close.bind(this.menu, false), 300);
    }
}

export default MenuItem;